import './App.css';
import {Layout} from 'antd';
import SearchBar from "./components/SearchBar/SearchBar";
import {useCallback, useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {searchSelector, settingsSelector} from "./store/store";
import {searchQueryAction, loadPreviousSearchQueries} from "./store/actions/search-actions";
import {changeSettings} from "./store/actions/settings-actions";
import ResultPanel from "./components/ResultPanel/ResultPanel";
import PdfUploader from "./components/PdfUpload/PdfUploader";

const {Header, Content} = Layout

const App = () => {

    const [query, setQuery] = useState('');

    const dispatch = useDispatch()

    const { isLoading, results, previousQueries } = useSelector(searchSelector)
    const settings  = useSelector(settingsSelector)

    useEffect(() => {
        // Загружаем ранее введенные запросы при старте приложения
        dispatch(loadPreviousSearchQueries());
    }, [dispatch]);

    const handleSearch = useCallback((query) => {
        console.log(`Search query: ${query}`);
        setQuery(query);
        dispatch(searchQueryAction(query, previousQueries, settings.rank))
    }, [dispatch, previousQueries])

    const clearSearch = useCallback(() => {
        console.log('Clear search');
        setQuery('');
    }, []);

    const handleSettings = useCallback((settings) => {
        dispatch(changeSettings(settings))
    }, [dispatch]);

    const SearchBarPanel = () =>
        <SearchBar
            query={query}
            queries={previousQueries}
            isSearching={isLoading}
            settings={settings}
            handleSettings={handleSettings}
            handleSearch={handleSearch}
            clearSearch={clearSearch}
        />

    const hasResult = results && results.length > 0

    return (
        <Layout className="App" style={{height: '100%'}}>
            <Header className="Header"
                    style={{position: 'fixed', zIndex: 3, display: 'flex', width: '100%', height: '120px'}}>
                <div style={{flexGrow: 400, display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                    {hasResult && <SearchBarPanel style={{padding: '10px 50px',}}/>}
                </div>
                <div style={{flexGrow: 1}}>
                    <PdfUploader/>
                </div>
            </Header>
            <Content className="Content">
            { hasResult
                    ? <ResultPanel data={results} />
                    : <SearchBarPanel/>
                }
            </Content>
        </Layout>
    );
}

export default App;
